import _ from "lodash";
import {
  Component,
} from "react";
import {
  renderChildren,
  withLocation,
} from "CommonCore/router-util";
import {
  Button,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
} from "react-bootstrap";
import {
  popAndReplaceComponent,
  getPathComponent,
} from "CommonCore/location-util";
import store from "CommonState/store";
import uiconfig, {
  ifAllowed,
} from "CommonState/uiconfig";
import Breadcrumb from "CommonComponents/breadcrumb";
import {
  Awesome,
} from "CommonComponents/bricks";
import {
  updateStats,
} from "Components/db-widget-angaben";
import PersonValidierungPopup from "App/person-validierung-popup";
import {
  ASTMODUSKEY,
} from "App/constants";
import {
  getModus,
} from "App/antragsteller-modus";

@withLocation
@uiconfig
@ifAllowed("page.person")
@store("flag_angabenstatus", "flag_antragstellermodus", "user")
export default class PersonPage extends Component {
  constructor() {
    super();
    this.state = { validierung: false };
  }

  async componentDidUpdate(prevProps) {
    if (prevProps.flag_antragstellermodus !== this.props.flag_antragstellermodus) {
      await updateStats(this.props);
    }
  }

  componentDidMount = async() => {
    const modus = await getModus(this.props);
    await updateStats(this.props, modus);
  };


  render() {
    const { location, flag_antragstellermodus } = this.props;
    const { validierung } = this.state;
    const tab = getPathComponent(location, 2);
    const crumbs = [{
      name: "Person",
      path: "/person",
    }];

    const vortragvertrag = flag_antragstellermodus == ASTMODUSKEY.Vortrag;
    const werkvertrag = flag_antragstellermodus == ASTMODUSKEY.WerkPrivat;
    const lehrvertrag = flag_antragstellermodus == ASTMODUSKEY.Lehrauftrag;
    const tarifvertrag = flag_antragstellermodus == ASTMODUSKEY.Tarif;

    const TabIcon = ({ tag }) => {
      const { flag_angabenstatus } = this.props;
      if (!flag_angabenstatus) {
        return null;
      }
      let list = [];
      if (!_.isArray(tag)) {
        list.push(tag);
      } else {
        list = tag;
      }
      let count = 0;
      _.map(list, name => {
        if (!_.isEmpty(flag_angabenstatus[name])) {
          count += flag_angabenstatus[name].length;
        }
      });

      return <span>{flag_angabenstatus && count == 0 && <Awesome name='check-circle' />} </span>;
    };

    const NavIcons = () => {
      const navIcons = [];
      navIcons.push(
        <NavItem key='stamm'><NavLink eventKey='stamm'>
          <TabIcon tag='person' />
          Persönliche Daten
        </NavLink></NavItem>,
      );

      if (!werkvertrag && !vortragvertrag) {
        navIcons.push(
          <NavItem key='studium'><NavLink eventKey='studium'>
            <TabIcon tag={["studienbereich", "werdegang"]} />
            {lehrvertrag ? "Qualifikation" : tarifvertrag ? "Ausbildung" : "Studentische / Wissenschaftliche Daten"}
          </NavLink></NavItem>,
        );

        if (!lehrvertrag) {
          navIcons.push(
            <NavItem key='steuer'><NavLink eventKey='steuer'>
              <TabIcon tag='lbvperson' />
              LBV 1: Persönliche Daten
            </NavLink></NavItem>,
          );
          navIcons.push(
            <NavItem key='status'><NavLink eventKey='status'>
              <TabIcon tag='lbvstatus' />
              LBV 2: Status
            </NavLink></NavItem>,
          );
        }

        if (!lehrvertrag) {
          navIcons.push(
            <NavItem key='weiterebv'><NavLink eventKey='weiterebv'>
              <TabIcon tag='weiterebv' />
              vorherige / weitere Beschäftigungsverhältnisse
            </NavLink></NavItem>,
          );
        }
      }
      return navIcons;
    };

    return <div>
      <Breadcrumb data={crumbs} />
      <Container fluid style={{ marginRight: 15 }}>
        <Row>
          <Nav variant='tabs' activeKey={tab} onSelect={this.navigate} id='ue-tabs'>
            {NavIcons()}
            <NavItem style={{ marginLeft: "auto" }}><Button style={{ marginTop: "2px", marginRight: "2px", marginBottom: "2px" }} onClick={this.startValidierung} variant='primary'>Daten prüfen</Button></NavItem>
            {validierung && <PersonValidierungPopup onClose={this.finishValidierung} />}

          </Nav>

        </Row>
        <Row className='tab'>
          {renderChildren(this.props)}
        </Row>
      </Container>
    </div>;
  }

  navigate = eventKey => {
    const { history, location } = this.props;
    history.push(popAndReplaceComponent(location, 2, eventKey));
  };

  finishValidierung = route => {
    this.setState({ validierung: false });
    if (route) {
      // Geschlossen mit Klick auf Link
      this.props.history.push("/");
      this.props.history.push(route);
    }
  };
  startValidierung = () => {
    this.setState({ validierung: true });
  };
}
